import { useState } from "react";
import FormTarea from "../../../pages/todo/FormTarea";
import { NavLink } from "react-router-dom";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Todo() {
    const [showForm, setShowForm] = useState(false);

    const navArray = [
        {
            nav : '/todo/tree',
            icon : <i className="ki-duotone ki-data fs-1 text-primary">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
                <span className="path5"></span>
            </i>,
            title : 'Proyectos',
            description : 'Proyectos en curso'
        },{
            nav : '/todo/list',
            icon : <i className="bi bi-list-task fs-1 text-primary"></i>,
            title : 'Tareas',
            description : 'Tareas individuales'
        },
    ]

    return (
        <div className="m-0 pt-2">
            <h1 className="text-gray-800 fw-semibold mb-6 mx-5">Menú</h1>
            <div className="mb-5">
                <button
                    className={"btn text-start w-100 custom-list bg-primary d-flex align-items-center px-5 py-4 rounded-1 bg-hover-primary-active"}
                    onClick={() => setShowForm(true)}
                >
                    <div className="symbol symbol-50px me-5">
                        <span className="symbol-label bg-white">
                            <i className="bi bi-node-plus fs-1 text-primary"></i>
                        </span>
                    </div>
                    <div className="d-flex flex-column flex-grow-1">
                        <h5 className="custom-list-title fw-semibold text-gray-200 mb-0">
                            Nueva Tarea
                        </h5>
                        <span className="text-gray-200 fw-semibold d-none d-sm-none d-md-none d-lg-block" style={{fontSize: '1rem'}}>
                            Crear nueva tarea
                        </span>
                    </div>
                </button>
                <FormTarea idParent={null} showForm={showForm} setShowForm={setShowForm}></FormTarea>
            </div>
            <div className="separator separator-dashed my-3"></div>
            <div className="mb-10">
                {
                    navArray && navArray.map((item) => {
                        return (
                            <NavLink
                                key={item.nav}
                                to={item.nav}
                                replace={true}
                                end
                                className={({ isActive }) => (isActive ? "bg-light-primary " : "") + "custom-list d-flex align-items-center px-5 py-4 bg-hover-light-primary"}
                            >
                                <div className="symbol symbol-50px me-5">
                                    <span className="symbol-label bg-gray-100">
                                        {
                                            item.icon
                                        }
                                    </span>
                                </div>
                                <div className="d-flex flex-column flex-grow-1">
                                    <h5 className="custom-list-title fw-semibold text-gray-800 mb-1">
                                        {item.title}
                                    </h5>
                                    <span className="text-gray-500 fw-bold">
                                        {item.description}
                                    </span>
                                </div>
                            </NavLink>
                        );
                    })
                }
            </div>
        </div>
    );
}
